import React from "react"
import { ProductOption } from "app/components/ProductOption"
import { useAppflow } from "app/hooks/useAppFlow"
import Heading from "app/components/Heading"
import { useTranslate } from "hooks/translate"
import { ENABLED_CAR_TYPES } from "../types"
import { StyledGrid } from "../style"

export const CarTypeSelector: React.FC = () => {
  const { navigate, clientType } = useAppflow()
  const { t } = useTranslate()

  if (!clientType) return null

  return (
    <div>
      <div>
        <Heading>{t("system.car_type")}</Heading>
        <StyledGrid>
          {ENABLED_CAR_TYPES.map(carType => (
            <ProductOption
              key={carType}
              title={t(`system.car_type.${carType}`)}
              description={t(`system.car_type.${carType}.description`)}
              onClick={() => navigate(clientType, carType)}
            />
          ))}
        </StyledGrid>
      </div>
    </div>
  )
}
